module.exports = __webpack_public_path__ + "img/lpcosmeticos.f39addb8.svg";